import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/gallery/:gallerySlug',
		name: 'PublicUploadPortal',
		component: () => import('@/views/PublicUploadPortal.vue'),
		props: true,
		meta: {
			requiresAuth: false,
			layout: 'LayoutDefault',
		},
	},
];

export default routes;
